import React, { useCallback, useEffect, useState } from "react";

import Table from "../../components/table/Table";
import { employee } from "./content";

import CustomPopup from "../../components/CustomPopup/CustomPopup";
import { Col, Row } from "react-bootstrap";
import CustomInput from "../../components/common/Input/Input";
import { Controller, useForm } from "react-hook-form";
import CustomSelect from "../../components/common/Select/Select";
import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment";
import { debounce } from "lodash";

const Employee = () => {
  const { doLogin, currUserData } = useAuthContext();
  const [popupShow, setPopupShow] = useState(false);
  const [data, setData] = useState(employee);
  const [editData, setEditData] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [optionsGender, setOptionsGender] = useState([
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ]);
  const [optionsRole, setOptionsRole] = useState([]);

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const handleDelete = async (rowIndex, id) => {
    let res = await api(
      `api/v1/internalEmployee/delete/${id}`,
      {},
      "delete",
      currUserData?.token,
      "Delete Successfully"
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);
      console.log(res, "delete");
      setData((prevCountryData) => {
        if (!Array.isArray(prevCountryData)) {
          return prevCountryData; // Exit if prevCountryData is not correctly set
        }
        // Filter out the country by index
        const newData = prevCountryData.filter(
          (_, index) => index !== rowIndex
        );
        // Proceed with the backend delete API call
        return newData; // Return the updated data to set the new state
      });
      // setData(res.faqs);
      // setIsLoading(false);
    }
  };

  const handleEdit = async (original) => {
    console.log(original, "jdjdj");
    setPopupShow(true);

    setEditData(original);
    const fields = ["name", "email", "phone"];

    fields.forEach((field) => setValue(field, original[field]));

    const selectedRole = { label: original.role, value: original.role };

    setValue("role", selectedRole || null);
    // setValue("gender", { label: "Female", value: "Female" });
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getEmployeeData(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const registerOptions = {
    name: { required: "Name is required" },
    email: {
      required: "Email is required",
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Enter a valid email address",
      },
    },
    phone: {
      required: "Phone Number is required",
      pattern: {
        value: /^[0-9]{10}$/, // Ensures exactly 10 digits
        message: "Enter a valid 10-digit phone number",
      },
    },
  };
  const AddEmployee = async (data) => {
    console.log(data, "form sdf");

    var payload = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      role: data?.role.value,
    };
    const editPayload = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      role: data?.role.value,
    };
    if (editData) {
      let res = await api(
        `api/v1/employee/updateEmployee/${editData._id}`,
        editPayload,
        "put",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        setEditData("");
        setPopupShow(false);
        reset();
        getEmployeeData();
      }
    } else {
      let res = await api(
        `api/v1/employee/addEmployee`,
        payload,
        "post",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        setPopupShow(false);
        reset();
        getEmployeeData();
      }
    }
  };

  const getEmployeeData = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/employee/getEmployees?page==${
        pageIndex + 1
      }&limit=${pageSize}&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setData(res?.response);
      setIsLoading(false);
      setTotalCount(res?.totalCount);
    }
  };

  const handleToggleStatus = (rowIndex) => {
    // const newData = [...data];
    // newData[rowIndex].status = !newData[rowIndex].status;
    // setData(newData);
  };

  const DeleteEmployee = async (id) => {
    const res = await api(
      `api/v1/employee/deleteEmployee/${id}`,
      {},
      "delete",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      getEmployeeData();
    }
  };

  const getRoleData = async () => {
    let res = await api(
      `api/v1/role/getRoles?page=1&limit=20`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      const roleOptions = res.data.items.map((item) => ({
        label: item.name, // Show "name" in dropdown
        value: item.name, // Return "_id" on select
      }));
      setOptionsRole(roleOptions);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Full Name",
        accessor: "name",
      },
      {
        Header: "Phone Number",
        accessor: "phone",
      },
      {
        Header: "Email ID",
        accessor: "email",
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => (
          <div class="form-check form-switch">
            <input
              onChange={() => handleToggleStatus(row.index)}
              className="form-check-input"
              type="checkbox"
              id="mySwitch"
              name="darkmode"
              value="yes"
              checked={row.original.status === 1 ? true : false}
            />
          </div>
        ),
      },
      {
        Header: "Created On",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.createdAt, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div class="dropdown">
            <span
              data-bs-toggle="dropdown"
              style={{ cursor: "pointer" }}
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </span>
            <ul class="dropdown-menu">
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleEdit(row.original);
                  }}
                >
                  Edit
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => DeleteEmployee(row.original._id)}
                >
                  Delete
                </span>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    getEmployeeData();
  }, [pageIndex, pageSize]);
  useEffect(() => {
    getRoleData();
  }, []);

  return (
    <>
      <div className="employee_management">
        <div className="p-40">
          <div className="page_heading mb-4">
            <div>
              <p className="heading">Employee</p>
            </div>
            <button
              className="btn_primary"
              onClick={() => {
                setPopupShow(!popupShow);
                setEditData("");
                reset();
              }}
            >
              + Add Employee
            </button>
          </div>

          <div className="employee_list ">
            <Table
              columns={columns}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggleStatus={handleToggleStatus}
              onSearch={handelSearch}
              isLoading={isLoading}
              totalCount={totalCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              setPageIndex={setPageIndex}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </div>

      <CustomPopup
        show={popupShow}
        close={setPopupShow}
        closeIcon={true}
        id="Add Employee"
        title="Add Employees"
        bg={false}
        width="lg"
      >
        <form className="w-100  p-5" onSubmit={handleSubmit(AddEmployee)}>
          <Row>
            <Col md="6">
              <CustomInput
                register={register}
                label="Full Name"
                name="name"
                placeholder="e.g., Suraj"
                type={"text"}
                errors={errors.name}
                validation={registerOptions.name}
              />
            </Col>
            <Col md="6">
              <CustomInput
                register={register}
                label="Email ID"
                name="email"
                placeholder="e.g., surajkumar@gmail.com"
                type={"text"}
                errors={errors.email}
                validation={registerOptions.email}
              />
            </Col>
            <Col md="6">
              <CustomInput
                register={register}
                label="Phone Number"
                name="phone"
                placeholder="e.g., 9087898799"
                type={"text"}
                errors={errors.phone}
                validation={registerOptions.phone}
                onInput={(e) => {
                  if (e.target.name === "phone") {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }
                }}
              />
            </Col>

            <Col sm={6}>
              <Controller
                name="role"
                control={control}
                defaultValue={null}
                rules={{ required: "Role is required" }}
                render={({ field }) => (
                  <CustomSelect
                    label="Role"
                    name="role"
                    options={optionsRole}
                    field={field}
                    customLabel=""
                    errors={errors.role}
                    isDisabled={editData}
                  />
                )}
              />
            </Col>
          </Row>
          <button
            className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
          >
            Submit
          </button>
        </form>
      </CustomPopup>
    </>
  );
};

export default Employee;
